// import React from 'react'
import { PhoneNumberUtil, PhoneNumberFormat, PhoneNumber } from 'google-libphonenumber'
import { TextField, TextFieldProps } from './TextField'

export class PhoneField extends TextField {
  pn: PhoneNumberUtil
  constructor(props?: TextFieldProps, context?: any) {
    super(props, context)
    this.pn = PhoneNumberUtil.getInstance()
  }

  onBlurHandler(v: string) {
    let phoneNumber: PhoneNumber
    try {
      phoneNumber = this.pn.parse(v)
      v = this.pn.format(phoneNumber, PhoneNumberFormat.INTERNATIONAL)
    } catch (e) { }

    super.onBlurHandler(v)
  }

  getErrorText(): string {
    const error = super.getErrorText()
    if (error) {
      return error
    }

    if (this.hasValue()) {
      const msg = 'Please enter a valid international phone number, which starts with the plus and your country code (e.g. +61 2 9999 9999 or +61 499 999 999)'
      try {
        const phoneNumber = this.pn.parse(this.getValue())
        if (!this.pn.isValidNumber(phoneNumber)) {
          return msg
        }
      } catch (e) {
        return msg
      }
    }
    return null
  }
}
